<template>
  <div>
    <br />

    <div class="row text-center">
      <span class="p-2">
        Commande Référence Nº :
        <span class="fw-bold">
          {{ $route.params.reference }}
        </span>
      </span>
    </div>
    <br />
    <div class="row justify-content-center">
      <div v-if="order.reference" class="col-auto p-1">
        <button
          @click="refresh()"
          class="btn border text-secondary borde-secondary"
        >
          <i class="bi bi-check2-square text-secondary fs-4"></i> Valider
        </button>
      </div>

      <div v-if="order.reference" class="col-auto p-1">
        <button
          @click="refresh()"
          class="btn border text-secondary borde-secondary"
        >
          <i class="bi bi-pencil-square text-secondary fs-4"></i> Modifier
        </button>
      </div>
      <div v-if="order.reference" class="col-auto p-1">
        <button
          @click="printPOS(order.reference)"
          class="btn border text-secondary borde-secondary"
        >
          <i class="bi bi-printer text-secondary fs-4"></i> Imprimer POS
        </button>
      </div>

      <div v-if="order.reference" class="col-auto p-1">
        <button
          @click="printPurchaseOrder(order.reference)"
          class="btn border text-secondary borde-secondary"
        >
          <i class="bi bi-printer text-secondary fs-4"></i> Imprimer Bon CMD
        </button>
      </div>
      <div class="col-auto p-1">
        <button
          @click="refresh()"
          class="btn border text-secondary borde-secondary"
        >
          <i class="bi bi-arrow-clockwise text-secondary fs-4"></i> Actualiser
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="width: 25%"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
        <span>
          <i class="bi bi-check-circle"></i>
        </span>

        <div
          class="progress-bar"
          role="progressbar"
          style="width: 25%"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
        <span>
          <i class="bi bi-basket3"></i>
        </span>
      </div>
    </div>
    <hr />
    <div class="row align-items-stretch">
      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Client</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer">
              {{ order.customer.fullName }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nº de Téléphone</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer">
              {{ order.customer.phone }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nom Commercial (Société)</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer">
              {{ order.customer.society }}
            </span>
          </div>
        </div>
      </div>
      <!-- ***** -->
      <div class="col-4 justify-content-between">
        <div class="row">
          <div class="col p-1">Quantité totale</div>
          <div v-if="order.totalQuantity" class="col p-1 fw-bold">
            {{ order.totalQuantity }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total TTC</div>
          <div v-if="order.totalPriceTTC" class="col p-1 fw-bold">
            {{ order.totalPriceTTC }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total HT</div>
          <div v-if="order.totalPriceHT" class="col p-1 fw-bold">
            {{ order.totalPriceHT }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total TVA</div>
          <div v-if="order.totalPriceTVA" class="col p-1 fw-bold">
            {{ order.totalPriceTVA }}
          </div>
        </div>
      </div>
      <!--  -->
      <div class="col-4 justify-content-between">
        <div class="row">
          <div class="col p-1">Total Payé :</div>
          <div class="col p-1 fw-bold">
            {{ order.amountPaid }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Impayé :</div>
          <div class="col p-1 fw-bold">
            {{ order.amountUnpaid }}
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="row align-items-stretch">
      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">État de livraison</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Livré par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Livré le :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Vérifié (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Validé (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="order.customer"> - </span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Nom</th>
          <th scope="col">Quantité</th>
          <th scope="col">Prix U (TTC)</th>
          <th scope="col">M. Total</th>
          <th scope="col">Créer par</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in order.order_items" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ item.item_reference }}
          </td>
          <td>
            <span v-if="item.item">
              {{ item.item.fullName }}
            </span>
          </td>
          <td>{{ item.quantity }}</td>
          <td class="text-warning">
            {{ item.priceTTC }}
          </td>
          <td class="text-warning">
            {{ item.totalPriceTTC }}
          </td>
          <td class="text-success">
            {{ item.payrollAmount }}
          </td>

          <td>
            <span v-if="item.user">
              {{ item.user.name }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("order/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("order", {
      order: "getOrder",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("order/show", this.$route.params.reference);
    },
    async printPurchaseOrder(reference) {
      await this.$store.dispatch("order/printPurchaseOrderPage", reference);
    },
    async printPOS(reference) {
      await this.$store.dispatch("order/printPosPage", reference);
    },
  },
};
</script>
